module.exports = __webpack_public_path__ + "static/media/ASCEND_LNY21_HIGHFIVE.81b0565a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ASCEND_LNY21_HIGHFIVE.jpg
// module id = 436
// module chunks = 0